<template>
  <div>
    <p>redirecting ...</p>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "authenticiate"
});
</script>
